// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19FTm","colMin":"styles_colMin__12dJR"};